const model = [
  {
    key: 'sku',
    label: 'SKU',
  },
  {
    key: 'parentPostId',
    label: 'Parent Post ID',
  },
  {
    key: 'productName',
    label: 'Product Name',
    type: 'string',
  },
  {
    key: 'brandName',
    label: 'Brand Name',
    type: 'string',
  },
  {
    key: 'shortDescription',
    label: 'Short Description',
    type: 'string',
  },
];

export default model;
